import type { manage as en } from '@/i18n/locales/en/manage';
import type { Translation } from '@/i18n/types';

export const manage: Translation<typeof en> = {
  backToApp: 'Volver a la aplicación',
  sections: {
    companies: {
      label: 'Empresas',
      items: {
        companies: 'Empresas',
        pilots: 'Pilotos',
      },
    },
    people: {
      label: 'Personas',
      items: {
        users: 'Todos los usuarios',
        linkIdentities: 'Vincular identidades',
        admins: 'Administradores',
      },
    },
    audit: {
      label: 'Auditoría',
      items: {
        audit: 'Registro de auditoría',
      },
    },
    subscriptions: {
      label: 'Suscripciones',
      items: {
        config: 'Provider configuration',
        products: 'Productos y proveedores',
        userLedger: 'Libro mayor de usuarios',
      },
    },
    system: {
      label: 'Sistema',
      items: {
        statistics: 'Estado de estadísticas y reconstrucción',
        requests: 'Solicitudes de la API',
      },
    },
    support: {
      label: 'Soporte',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Resumen',
      items: {
        overview: 'KPI',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Estado de estadísticas y reconstrucción',
      note: 'El estado de las estadísticas y los controles de reconstrucción son un plan aparte — esta entrada de menú reserva el lugar, la pantalla no está construida en la fase 1.',
    },
  },
  usersAll: {
    title: 'Todos los usuarios',
    linkIdentities: 'Vincular identidades',
    empty: 'Aún no existen identidades.',
    name: 'Nombre',
    email: 'Correo electrónico',
    language: 'Idioma',
    login: 'Acceso',
    yes: 'sí',
    no: 'no',
    view: 'Ver',
    rowsLabel: 'los usuarios',
  },
  linkIdentities: {
    title: 'Vincular identidades duplicadas',
    lead: 'El alias se mantiene, pero apunta a la principal. A menos que seas administrador de la plataforma, una de las dos debe carecer de acceso y la identidad con acceso se convierte en la principal — el servidor lo comprueba, sea cual sea la elección aquí.',
    candidatesLabel: 'las personas que administras',
    needTwo: 'Necesitas al menos dos personas en tu ámbito para vincular.',
    aliasLabel: 'Alias (esta identidad se convierte en el puntero)',
    primaryLabel: 'Principal (la identidad que permanece)',
    choose: 'Elige…',
    hasLogin: '(tiene acceso)',
    noLogin: '(sin acceso)',
    link: 'Vincular',
    cancel: 'Cancelar',
  },
  erase: {
    completedTitle: 'Borrado completado',
    completedText:
      'La identidad ha sido borrada. El registro de auditoría queda seudonimizado, no eliminado; las identidades vinculadas se mantienen con su puntero reiniciado.',
    departmentsWithoutAdmin: 'Departamentos que se quedan sin administrador: {{names}}',
    measurementsNotDeleted:
      'Las mediciones en el servicio de ingesta NO se eliminaron — esa capacidad aún no existe allí. Haz un seguimiento fuera del panel.',
    backToUsers: 'Volver a usuarios',
    title: 'Borrar esta persona',
    lead: 'Esto elimina de forma irreversible y permanente la identidad {{userId}}: su fila de usuario, membresías, consentimientos y concesiones. Las identidades vinculadas se mantienen; los datos originados en Gengee permanecen; el registro de auditoría queda seudonimizado. Escribe {{confirmWord}} para confirmar.',
    confirmWord: 'BORRAR',
    confirmationLabel: 'Confirmación',
    erasePermanently: 'Borrar definitivamente',
    cancel: 'Cancelar',
  },
  requests: {
    title: 'Solicitudes de la API',
    lead: 'Las solicitudes registradas de la API de ingesta para un origen, empezando por las más recientes, opcionalmente acotadas a una ventana de tiempo.',
    filterSource: 'Filtrar por origen',
    sourcePlaceholder: 'id de origen',
    filterFrom: 'Desde',
    filterTo: 'Hasta',
    filter: 'Filtrar',
    enterSourceHint: 'Introduce un id de origen para cargar su registro de solicitudes.',
    empty: 'No hay solicitudes registradas para este origen y ventana.',
    when: 'Cuándo',
    method: 'Método',
    path: 'Ruta',
    status: 'Estado',
    rowsLabel: 'las solicitudes',
  },
};
